import { mainApi } from "services/main";
import {
  ExecuteApproverActionRequest,
  ExecuteRequesterActionRequest,
  GetApprovalRequest,
} from "./definitions";
import { ApprovalWorkflowResponse } from "components/create-edit-approval-modal/definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getApproval: builder.query<ApprovalWorkflowResponse, GetApprovalRequest>({
      query: (request: GetApprovalRequest) => ({
        url: "approval",
        params: {
          parentId: request.parentId,
          teamName: request.teamName,
        },
      }),
    }),
    executeRequesterAction: builder.mutation<
      ApprovalWorkflowResponse,
      ExecuteRequesterActionRequest
    >({
      query: (request: ExecuteRequesterActionRequest) => {
        return {
          url: `approval/${request.approvalId}/executeRequesterAction`,
          body: request,
          method: "PUT",
        };
      },
    }),
    executeApproverAction: builder.mutation<
      ApprovalWorkflowResponse,
      ExecuteApproverActionRequest
    >({
      query: (request: ExecuteApproverActionRequest) => {
        return {
          url: `approval/${request.approvalId}/executeApproverAction`,
          body: request,
          method: "PUT",
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetApprovalQuery,
  useExecuteApproverActionMutation,
  useExecuteRequesterActionMutation,
  usePrefetch,
} = extendedApi;
